export const USER_LIST_URL = 'user/list'
export const USER_LIST_ERROR = 'USER_LIST_ERROR'
export const USER_LIST_LOADING = 'USER_LIST_LOADING'
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS'

export const USER_BANK_LIST_URL = 'user/bank/list'
export const USER_BANK_LIST_ERROR = 'USER_BANK_LIST_ERROR'
export const USER_BANK_LIST_LOADING = 'USER_BANK_LIST_LOADING'
export const USER_BANK_LIST_SUCCESS = 'USER_BANK_LIST_SUCCESS'

export const USER_BANK_EDIT_URL = 'user/bank/edit'
export const USER_BANK_EDIT_ERROR = 'USER_BANK_EDIT_ERROR'
export const USER_BANK_EDIT_LOADING = 'USER_BANK_EDIT_LOADING'
export const USER_BANK_EDIT_SUCCESS = 'USER_BANK_EDIT_SUCCESS'

export const USER_ADD_URL = 'user/save'
export const USER_ADD_ERROR = 'USER_ADD_ERROR'
export const USER_ADD_LOADING = 'USER_ADD_LOADING'
export const USER_ADD_SUCCESS = 'USER_ADD_SUCCESS'

export const USER_CPW_URL = 'user/cpw'
export const USER_CPW_ERROR = 'USER_CPW_ERROR'
export const USER_CPW_LOADING = 'USER_CPW_LOADING'
export const USER_CPW_SUCCESS = 'USER_CPW_SUCCESS'
export const USER_CP_URL = 'forgot_password/change'
export const USER_CP_ERROR = 'USER_CP_ERROR'
export const USER_CP_LOADING = 'USER_CP_LOADING'
export const USER_CP_SUCCESS = 'USER_CP_SUCCESS'

export const USER_DELETE_URL = 'user/delete'
export const USER_DELETE_ERROR = 'USER_DELETE_ERROR'
export const USER_DELETE_LOADING = 'USER_DELETE_LOADING'
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS'

export const USER_VIEW_URL = 'user/view'
export const USER_VIEW_ERROR = 'USER_VIEW_ERROR'
export const USER_VIEW_LOADING = 'USER_VIEW_LOADING'
export const USER_VIEW_SUCCESS = 'USER_VIEW_SUCCESS'

export const USER_PAGE_URL = 'user/page'
export const USER_PAGE_ERROR = 'USER_PAGE_ERROR'
export const USER_PAGE_LOADING = 'USER_PAGE_LOADING'
export const USER_PAGE_SUCCESS = 'USER_PAGE_SUCCESS'

export const USER_EDIT_URL = 'user/update'
export const USER_EDIT_ERROR = 'USER_EDIT_ERROR'
export const USER_EDIT_LOADING = 'USER_EDIT_LOADING'
export const USER_EDIT_SUCCESS = 'USER_EDIT_SUCCESS'

export const USER_SET_STATUS_URL = 'user/set_status'
export const USER_SET_STATUS_ERROR = 'USER_SET_STATUS_ERROR'
export const USER_SET_STATUS_LOADING = 'USER_SET_STATUS_LOADING'
export const USER_SET_STATUS_SUCCESS = 'USER_SET_STATUS_SUCCESS'

export const USER_SHIPPER_VIEW_URL = 'user/view'
export const USER_SHIPPER_VIEW_ERROR = 'USER_SHIPPER_VIEW_ERROR'
export const USER_SHIPPER_VIEW_LOADING = 'USER_SHIPPER_VIEW_LOADING'
export const USER_SHIPPER_VIEW_SUCCESS = 'USER_SHIPPER_VIEW_SUCCESS'

export const USER_CONSIGNEE_LIST_URL = 'user/list'
export const USER_CONSIGNEE_LIST_ERROR = 'USER_CONSIGNEE_LIST_ERROR'
export const USER_CONSIGNEE_LIST_LOADING = 'USER_CONSIGNEE_LIST_LOADING'
export const USER_CONSIGNEE_LIST_SUCCESS = 'USER_CONSIGNEE_LIST_SUCCESS'

export const USER_SHIPPER_LIST_URL = 'user/list'
export const USER_SHIPPER_LIST_ERROR = 'USER_SHIPPER_LIST_ERROR'
export const USER_SHIPPER_LIST_LOADING = 'USER_SHIPPER_LIST_LOADING'
export const USER_SHIPPER_LIST_SUCCESS = 'USER_SHIPPER_LIST_SUCCESS'

export const STATUS_USER_URL = 'dashboard/status_user'
export const STATUS_USER_ERROR = 'STATUS_USER_ERROR'
export const STATUS_USER_LOADING = 'STATUS_USER_LOADING'
export const STATUS_USER_SUCCESS = 'STATUS_USER_SUCCESS'

export const USER_REPORT_URL = 'user/report'
export const USER_REPORT_ERROR = 'USER_REPORT_ERROR'
export const USER_REPORT_LOADING = 'USER_REPORT_LOADING'
export const USER_REPORT_SUCCESS = 'USER_REPORT_SUCCESS'